export default "__VITE_ASSET__882af9fa__"